import React from "react";
const brandVoucherImage =
  "https://res.cloudinary.com/dyyjph6kx/image/upload/v1638764214/store/admin/Image.png";

import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

import styled from "styled-components";

const StyledDiv = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;
const DividerDiv = styled.div`
  padding: 16px 0 0;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const BorderDiv = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const RewardDiv = styled.div`
  width: 40%;
  padding: 12px 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const PointsDiv = styled.div`
  width: 40%;
  padding: 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const WorthDiv = styled.div`
  width: 30%;
  padding: 14px 0 14px 32px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const ExpiryDiv = styled.div`
  width: 30%;
  padding: 14px 0 14px 32px;
`;
const ValidityDiv = styled.div`
  width: 30%;
  padding: 20px 0 20px 32px;
`;

const XoxoLinkRewardBody = ({
  selectedValue,
  selectedDate,
  validTill,
  isDesktopPreview,
}) => {
  return (
    <>
      {isDesktopPreview ? (
        <StyledDiv className="xoxo-point-reward-body-desktop d-flex mt-16">
          <div className="d-flex">
            <RewardDiv>
              <Typography.HelperText className="mb-0" color="dark" shade="c200">
                Your Reward
              </Typography.HelperText>
            </RewardDiv>
            <WorthDiv>
              <Typography.HelperText className="mb-0" color="dark" shade="c200">
                Worth
              </Typography.HelperText>
            </WorthDiv>
            <ExpiryDiv>
              <Typography.HelperText className="mb-0" color="dark" shade="c200">
                Expires on
              </Typography.HelperText>
            </ExpiryDiv>
          </div>
          <BorderDiv />
          <div className="d-flex">
            <PointsDiv>
              <Typography.HelperText color="orange" shade="c200">
                <div className="d-flex align-items-center">
                  <div>
                    <img
                      style={{
                        width: "55px",
                        height: "36px",
                        marginRight: "10px",
                      }}
                      src={brandVoucherImage}
                    />
                  </div>
                  <div>
                    <Typography className="mb-0" color="dark" shade="c300">
                      Xoxo Link
                    </Typography>
                  </div>
                </div>
              </Typography.HelperText>
            </PointsDiv>
            <WorthDiv>
              <Typography.HelperText
                color="dark"
                shade="c300"
                className="mt-16"
              >
                {selectedValue}
              </Typography.HelperText>
            </WorthDiv>
            <ValidityDiv>
              <Typography.HelperText
                color="dark"
                shade="c200"
                className="mt-12"
              >
                {validTill}
              </Typography.HelperText>
            </ValidityDiv>
          </div>
          <div></div>
        </StyledDiv>
      ) : (
        <StyledDiv className="xoxo-point-reward-body mt-16">
          <Typography.HelperText className="mb-16" color="dark" shade="c200">
            Your Reward
          </Typography.HelperText>
          <Typography color="orange" shade="c200">
            <div className="d-flex align-items-center">
              <div>
                <img
                  style={{ width: "55px", height: "36px", marginRight: "10px" }}
                  src={brandVoucherImage}
                />
              </div>
              <div>
                <Typography className="mb-0" color="dark" shade="c300">
                  Xoxo Link
                </Typography>
              </div>
            </div>
          </Typography>
          <DividerDiv></DividerDiv>
          <Typography.HelperText className="mb-8" color="dark" shade="c200">
            Worth
          </Typography.HelperText>
          <Typography color="dark" shade="c300" className="mb-12">
            {selectedValue}
          </Typography>
          <DividerDiv></DividerDiv>
          <Typography.HelperText className="mb-8" color="dark" shade="c200">
            Expires on
          </Typography.HelperText>
          <Typography.HelperText color="dark" shade="c300">
            {validTill}
          </Typography.HelperText>
        </StyledDiv>
      )}
    </>
  );
};

export default XoxoLinkRewardBody;
